// CORE (da inserire nel bundle principale)
import _scrollTo from "./_core/_scrollto.controls.ts";
_scrollTo.init();

// ENGINE
const menu = {
    menuBar: document.getElementById("navbar"),
    menuContent: document.getElementById("navpage"),
    menuButton: document.getElementById("navbar")?.querySelector("button"),
}
if(menu.menuBar && menu.menuContent && menu.menuButton) {
    import('./_engine/_menu.controls.ts').then(({default: _menuControls}) => {
        _menuControls.init(menu.menuBar!, menu.menuContent!, menu.menuButton!);
    });
}

// FORMS
const forms = document.getElementsByTagName("form");
if (forms && forms.length > 0) {
    import("./_formValidation/_validation.bootstrapper.ts").then(({ default: _validationBootstrapper }) => {
        _validationBootstrapper.init(forms);
    });
}

const formRichiediPreventivo = document.getElementById("form-richiedi-preventivo")

if(document.getElementById("form-contatto") || formRichiediPreventivo) {
    import('./_formValidation/_formDataEtaBambini.ts').then(({default: _form}) => {
        _form.init();
    });
}

if(formRichiediPreventivo) {
    import('./_formValidation/_formRichiediPreventivo.ts').then(({default: _formRichiediPreventivo}) => {
        _formRichiediPreventivo.init(formRichiediPreventivo);
    });
}

// LIBRARIES
const swiper = document.querySelector(".swiper");
if (swiper) {
    import("./_engine/_swiper.controls.ts").then(({ default: _swiperControls }) => {
        _swiperControls.init();
    });
}

const lightbox = document.querySelector("[data-fslightbox]");
if (lightbox) {
    // @ts-ignore
    import("fslightbox");
}

// BLOCKS
const accordions = document.querySelectorAll(".accordion-container");
if (accordions && accordions.length > 0) {
    import("./_blocks/_accordion.ts").then(({ default: _accordion }) => {
        _accordion.init(accordions);
    });
}
const puntoElencoPersonalizzato = document.querySelectorAll(".punto-elenco-personalizzato");
if (puntoElencoPersonalizzato && puntoElencoPersonalizzato.length > 0) {
    import("./_blocks/_puntoElencoPersonalizzato.ts").then(({ default: _puntoElencoPersonalizzato }) => {
        _puntoElencoPersonalizzato.init(puntoElencoPersonalizzato);
    });
}

// ELEMENTS
const buttons = document.querySelectorAll(".template-cta:has(circle)");
if(buttons && buttons.length > 0) {
    import('./_elements/_ctaCircle.ts').then(({default: _ctaCircle}) => {
        _ctaCircle.init(buttons);
    });
}

const listatoaHotels = document.querySelector(".listato-hotels .lista") as Element;
const controllerHotels = document.querySelector(".listato-hotels .controller") as Element;
if(listatoaHotels && controllerHotels) {
    import('./_elements/_listaHotels.ts').then(({default: listaHotels}) => {
        listaHotels.init(controllerHotels, listatoaHotels);
    });
}

const listatoOfferte = document.querySelector(".listato-offerte .lista") as Element;
const controllerOfferte = document.querySelector(".listato-offerte .controller") as Element;
if(listatoOfferte && controllerOfferte) {
    import('./_elements/_listaOfferte.ts').then(({default: listaOfferte}) => {
        listaOfferte.init(controllerOfferte, listatoOfferte);
    });
}

const floatLabels = document.querySelectorAll(".float-label");
if(floatLabels && floatLabels.length > 0) {
    import('./_core/_floatLabels.ts').then(({default: _floatLabels}) => {
        _floatLabels.init(floatLabels);
    });
}

const extraDatesBtn = document.getElementById("extra-dates");
if(extraDatesBtn) {
    const dates = document.querySelectorAll("input[type=date]");
    import('./_elements/_extraDates.ts').then(({default: _extraDates}) => {
        _extraDates.init(extraDatesBtn, dates);
    });
}

const map = document.getElementById("map");
if(map) {
    import('./_elements/_mapCards.ts').then(({default: _mapCards}) => {
        _mapCards.init(map);
    });
}

const readMoreEls = document.querySelectorAll("[data-read-more]");
if(readMoreEls) {
    import('./_engine/_readMore.controls.ts').then(({default: readMore}) => {
        readMoreEls.forEach(el => {
            readMore.init(el);
        })
    });
}


// PAGES
if(document.body.classList.contains("hotel"))
    import('./_pages/_hotel.ts').then(({default: _hotel}) => {
        _hotel.init();
    });

// VARIE ED EVENTUALI

// Da attivare solo nel caso in cui nel sito sono presenti fasce
// che usano il pin dello scroll-trigger, assieme a fasce che cambiano di dimensione
const needsResizeChecker = false;
if (needsResizeChecker) {
    import("./_core/_resizeChecker.ts").then(({ default: _resizeChecker }) => {
        _resizeChecker.init();
    });
}
